import { render, staticRenderFns } from "./CalculateSalaryProcessLucaUploadFile.vue?vue&type=template&id=6b45566b&"
import script from "./CalculateSalaryProcessLucaUploadFile.vue?vue&type=script&lang=js&"
export * from "./CalculateSalaryProcessLucaUploadFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports